import { render, staticRenderFns } from "./SellersManagements.vue?vue&type=template&id=60bbcde4&scoped=true&"
import script from "./SellersManagements.vue?vue&type=script&lang=js&"
export * from "./SellersManagements.vue?vue&type=script&lang=js&"
import style0 from "@@/core/pages/SalesManagement/SalesManagementsList/SellersStyle.css?vue&type=style&index=0&id=60bbcde4&scoped=true&lang=css&"
import style1 from "./SellersManagements.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bbcde4",
  null
  
)

export default component.exports